import { render } from "./Preview.vue?vue&type=template&id=47933a3b"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=47933a3b&lang=scss"
script.render = render

export default script